import {Button, Div, HeaderBack, ImageView, Label} from 'components';
import {Ecolors, Efonts, Icons} from 'constant';
import React, {useEffect} from 'react';
import {getStatusEditProfile} from 'reducer/authen/selector';
import {navigate} from 'services';
import {useAppDispatch, useAppSelector} from 'store/hooks';
import {removeUtf8} from 'utils';
import ItemCard from './ItemCard';
import {ScrollView} from 'react-native';
import {convertchangeIdNoStatus} from '../ChangeCMNDtoCCCDScreen/api';
import {getInfo} from 'reducer/authen';

function RowSpaceItem(p: {paddingTop?: number; children?: any}) {
  return (
    <Div
      minHeight={54}
      paddingHorizontal={16}
      borderBottomWidth={1}
      borderBottomColor={Ecolors.spaceColor}
      paddingVertical={10}
      flexDirection={'row'}
      alignItems={'center'}
      justifyContent={'space-between'}>
      {p.children && p.children}
    </Div>
  );
}

function BankInfoModal() {
  const currentUser = useAppSelector(state => state.authen.currentUser);
  const isEdit = useAppSelector(state => getStatusEditProfile(state));

  const {
    bankAccount,
    changeBankInfoStatus,
    investmentProfile,
    bankAccountIsFull,
    changeBankInfo,
  } = currentUser;
  const dispatch = useAppDispatch();

  useEffect(() => {
    dispatch(getInfo({}));
  }, [bankAccount?.branchId]);

  const iconEdit = () => {
    const currentProfileStatus = investmentProfile?.status?.code;

    const statuses = [
      'INVESTMENT_PROFILE_ACCEPT',
      'INVESTMENT_PROFILE_APPROVE',
    ];

    const isProfileApproved = statuses.includes(currentProfileStatus);

    if (
      !bankAccountIsFull || // Mới tạo account, chưa điền đầy đủ thông tin
      (isProfileApproved && changeBankInfo == 1) || // Đã xác thực và trạng thái là approved hoặc reject
      !currentProfileStatus // Chưa xác thực
    ) {
      return Icons.edit;
    }
    return null;
  };

  return (
    <Div height={'100%'} backgroundColor={Ecolors.whiteColor}>
      <HeaderBack
        type={2}
        iconRight={iconEdit()}
        title={`accountverify.thongtinnganhang`}
        onRightPress={() => {
          navigate('EditBankInfoModal');
        }}
      />

      {!!changeBankInfoStatus && (
        <Button
          onPress={() => {
            navigate('ChangeCMNDtoCCCDDetailsScreen', {change: 'bank'});
          }}>
          <RowSpaceItem>
            <Label>{`changecmnd.trangthaihoso`}</Label>
            <Div
              flexDirection="row"
              alignItems="center"
              justifyContent="flex-end">
              <Label
                fontFamily={Efonts.italic}
                color={convertchangeIdNoStatus(changeBankInfoStatus).color}
                multilanguage={false}>
                {convertchangeIdNoStatus(changeBankInfoStatus).title}
              </Label>
              <ImageView
                marginLeft={5}
                widthHeight={12}
                source={Icons.forward}
                resizeMode="contain"
              />
            </Div>
          </RowSpaceItem>
        </Button>
      )}

      <ScrollView style={{flex: 1}}>
        <ItemCard
          title={`accountverify.tenchutaikhoan`}
          content={removeUtf8(
            bankAccount?.name?.toLocaleUpperCase() ||
              currentUser?.name?.toLocaleUpperCase(),
          )}
          isLine={true}
        />
        <ItemCard
          title={`accountverify.sotaikhoan`}
          content={bankAccount?.number || ' '}
          isLine={true}
        />
        <ItemCard
          title={`accountverify.tennganhang`}
          content={bankAccount?.bankName || ' '}
          isLine={true}
        />
        <ItemCard
          title={`accountverify.chinhanh`}
          content={bankAccount?.branchName || ' '}
          isLine={true}
        />
        {currentUser?.bankAccountIsFull && (
          <>
            <ItemCard
              title={`accountverify.nghenghiep`}
              content={bankAccount?.job || '_'}
              isLine={true}
            />
            <ItemCard
              title={`accountverify.chucvu`}
              content={bankAccount?.position || '_'}
              isLine={true}
            />
          </>
        )}
      </ScrollView>
    </Div>
  );
}

export default React.memo(BankInfoModal);
